import { Callout } from "@fluentui/react";
import React, { useState } from "react";
import { Info } from "react-feather";
import {
  Link,
  getTheme,
  FontWeights,
  mergeStyleSets,
  Text,
} from "@fluentui/react";
import { useBoolean, useId } from "@fluentui/react-hooks";
import filter from "../shared/images/filter.PNG";
const theme = getTheme();
const styles = mergeStyleSets({
  buttonArea: {
    verticalAlign: "top",
    display: "inline-block",
    textAlign: "center",
    margin: "0 100px",
    minWidth: 130,
    height: 32,
  },
  callout: {
    maxWidth: 300,
  },
  header: {
    padding: "18px 24px 12px",
  },
  title: [
    theme.fonts.xLarge,
    {
      margin: 0,
      fontWeight: FontWeights.semilight,
    },
  ],
  inner: {
    height: "100%",
    padding: "0 24px 20px",
  },
  actions: {
    position: "relative",
    marginTop: 20,
    width: "100%",
    whiteSpace: "nowrap",
  },
  subtext: [
    theme.fonts.small,
    {
      margin: 0,
      fontWeight: FontWeights.semilight,
    },
  ],
  link: [
    theme.fonts.medium,
    {
      color: theme.palette.neutralPrimary,
    },
  ],
});

export const FilterCallOut = () => {
  const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(
    false
  );

  const labelId = useId("callout-label");
  const descriptionId = useId("callout-description");
  return (
    <div>
      <Info
        className="info"
        color="#1890FF"
        size="20"
        onClick={toggleIsCalloutVisible}
      />
      {isCalloutVisible && (
        <Callout
          className={styles.callout}
          ariaLabelledBy={labelId}
          ariaDescribedBy={descriptionId}
          role="alertdialog"
          gapSpace={0}
          target={".info"}
          onDismiss={toggleIsCalloutVisible}
          setInitialFocus
        >
          <div className={styles.header}>
            <Text className={styles.title} id={labelId}>
              Did you know?
            </Text>
          </div>
          <div className={styles.inner}>
            <div className="ms-Grid-row">
              <div
                className="ms-Grid-col ms-sm12"
                style={{ marginLeft: "-30px" }}
              >
                <img src={filter} alt="filter" />
              </div>
            </div>

            <Text className={styles.subtext} id={descriptionId}>
              Did you know you can also filter, sort,select or hide columns by
              clicking on column titles menu buttons?
            </Text>
            <div className={styles.actions}>
              <Link className={styles.link}>Go to Help Center</Link>
            </div>
          </div>
        </Callout>
      )}
    </div>
  );
};

